import React from "react";
import { setSidebarStatus } from "../../redux/actions/sidebar/sidebarAction";
import { connect } from "react-redux";
import { history } from "../../app/AppRouter";
import {
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Modal,
  ModalBody,
} from "reactstrap";
import logoutImage from "../../assets/images/logout.svg";
import logoutIcon from "../../assets/images/logout_icon.svg";
import { backToGym, logout } from "../../redux/actions/api/apiAction";
import { store } from "../../redux/storeConfig/store";
import { Link } from "react-router-dom";
import { setLoginUser } from "../../redux/actions/login/loginAction";
import { setStartStaffSessionModalOpen, setEndStaffSessionModalOpen, setVerifyAndInfoStaffSessionsModalOpen } from "../../redux/actions/staffSession/staffSessionAction";
import StartStaffSessionForm from "../../components/staffSession/start/startStaffSessionForm";
import VerifyAndInfoStaffSessionsForm from "../../components/staffSession/verifyAndInfoSessions/verifyAndInfoStaffSessionForm";
import ModalHeader from "rsuite/esm/Modal/ModalHeader";
import GateSocketConnection from "../gate/gateSocketConnection";
import { CloseStaffSession } from "../modals/closeStaffSession";
import { cashesList } from "../appointment/utils";

class PrivateNavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutOpen: false,
      data: JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
        ? JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role
        : "",
      showBadge: Object.keys(this.props.loginUser).length ? true : false,
    };
  }

  componentDidUpdate = () => {
    if (!this.state.data) history.push("/");
  };

  logoutToggle = () => {
    this.setState({
      logoutOpen: !this.state.logoutOpen,
    });
  };
  basicInfo() {
    if (this.state.data && this.state.data === "GYM")
      history.push("/gym-panel/gyminfo");
    else if (this.state.data && this.state.data === "TRAINER")
      history.push("/trainer-panel/trainerinfo");
    else history.push("/");
  }

  getCurrentCashName () {
    let cashName = "";
    cashesList.map(c => {
      if (c.id == this.props?.currentStaffActiveSession?.cash) {
        cashName = c.label; 
      }
    });

    return cashName;
  }
  
  render() {
    let userData = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));

    return (
      <div>
        <Navbar color="white" light expand="xl" className="">
          <NavbarBrand
            onClick={(e) => {
              e.preventDefault();
              this.basicInfo();
            }}
          >
            <img
              src={require("../../assets/images/logo.svg")}
              className="img-fluid brand-logo"
              alt="logo"
            />
          </NavbarBrand>

          {Object.keys(this.props.loginUser).length > 0 && (
            <div className="user-navbar">
              {/* {
                this.props.gymFeaturesObject["gatesCheckinRealTimeMonitoring"] &&
              <GateSocketConnection gymId={this.props.gym.id}/>
              } */}
              {
                this.props.gymConfig?.switchStaff?.enabled &&
                <div className="d-flex align-items-center staff-session-container">
                  {
                    this.props.currentStaffActiveSession &&
                    <p className="current-cash-name">{this.getCurrentCashName()}</p>
                  }
                  <div className="position-relative mr-3 session-info"  onClick={() =>  this.props.setVerifyAndInfoStaffSessionsModalOpen(true)}>
                    <img
                      src={require("../../assets/images/info-circle.svg")}
                      className="session-info"
                      alt="sessions info"
                      style={{width: "34px"}}
                    />
                    {
                      this.props.currentStaffSessionsToVerify?.length > 0 &&
                      <span className="sessions-number">{this.props.currentStaffSessionsToVerify?.length}</span>
                    }
                  </div>
                  {
                    this.props.currentStaffActiveSession ?
                    <button className="btn mr-4" onClick={() =>  this.props.setEndStaffSessionModalOpen(true)}>
                      End Session
                    </button>
                    :
                    <button className="btn mr-4" onClick={() =>  this.props.setStartStaffSessionModalOpen(true)}>
                      Start Session
                    </button>
                  }
                  
                </div>
              }
              <div
                className="image-user-nav"
                style={{ display: "inline-flex" }}
              >
                <img
                  src={
                    this.props.gym.user && this.props.gym.user.image
                      ? this.props.gym.user.image
                      : require("../../assets/images/no_image.jpg")
                  }
                  className="img-fluid"
                  id="gymImg"
                  alt=""
                  style={{
                    display: "inline-flex",
                    maxWidth: "50px",
                    height: "50px",
                    borderRadius: "50%",
                  }}
                />
              </div>
              <div className="username-nav" style={{ display: "inline-flex" }}>
                <h4 className="f-bold mb-0 overflow-auto">
                  {this.props.gym.user && this.props.gym.user.name}
                </h4>
                {userData?.isSuperGymAdmin && (
                  <a
                    onClick={async() => {
                     await store.dispatch(backToGym(userData.id,userData.superGymAdminRedirectUrl))
                      store.dispatch(setLoginUser(undefined))
                    }}
                    className="mb-0 overflow-auto mr-3"
                    style={{ textDecoration: "underline", color: "purple" ,cursor: "pointer"}}
                    // href={`${userData.superGymAdminRedirectUrl}/dashboard`}
                  >
                    back to super gym admin
                  </a>
                )}
              </div>
              {!userData.isSuperGymAdmin && (
                <img
                  src={logoutImage}
                  className="logout-logo-nav"
                  alt="logout"
                  onClick={this.logoutToggle}
                />
              )}
            </div>
          )}

          <NavbarToggler
            onClick={async () => {
              await this.props.setSidebarStatus(!this.props.sidebarStatus);
            }}
          />
        </Navbar>
        <Modal
          isOpen={this.state.logoutOpen}
          toggle={this.logoutToggle}
          centered={true}
        >
          <ModalBody>
            <div className="logout-icon-modal">
              <img src={logoutIcon} alt="logout" />
            </div>
            <div className="logout-modal-text">
              <p>Are you sure you want to logout from your profile? </p>
            </div>
            <div className="action-wrapper blk-padding-y d-flex justify-content-center">
              <div className="action-inner-block">
                <div className="action-btn-block">
                  <span
                    className="btn btn-medium btn-transparent"
                    onClick={(e) => {
                      e.preventDefault();
                      this.logoutToggle();
                    }}
                  >
                    Cancel
                  </span>

                  <Link
                    to="/"
                    className="link-main-block"
                    onClick={() => store.dispatch(logout(userData.id))}
                  >
                    <button
                      value="Add Instructor"
                      className="btn btn-medium"
                      type="button"
                    >
                      Logout
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.props.startSessionModalOpen}
          toggle={() => {
            this.props.setStartStaffSessionModalOpen(!this.props.startSessionModalOpen);
          }}
          centered={true}
          size="md"
          className="wod-popup large-pop adding-popup add-gym-popup"
        >
          <StartStaffSessionForm />
        </Modal>
        <CloseStaffSession/>
        <Modal
          isOpen={this.props.verifyAndInfoSessionsModalOpen}
          toggle={() => {
            this.props.setVerifyAndInfoStaffSessionsModalOpen(!this.props.verifyAndInfoSessionsModalOpen);
          }}
          centered={true}
          size="lg"
          className="wod-popup large-pop adding-popup add-gym-popup"
        >
          <VerifyAndInfoStaffSessionsForm />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { sidebarStatus } = state.sidebar;
  const { gym, gymConfig } = state.gym;
  const { loginUser } = state.login;
  const { gymFeaturesObject } = state.features;
  const { startSessionModalOpen, currentStaffActiveSession, endSessionModalOpen, verifyAndInfoSessionsModalOpen, currentStaffSessionsToVerify } = state.staffSession;
  return { sidebarStatus, loginUser, gym, gymFeaturesObject, startSessionModalOpen, currentStaffActiveSession, endSessionModalOpen, verifyAndInfoSessionsModalOpen, currentStaffSessionsToVerify, gymConfig };
};
export default connect(mapStateToProps, { setSidebarStatus, logout, setStartStaffSessionModalOpen, setEndStaffSessionModalOpen, setVerifyAndInfoStaffSessionsModalOpen })(
  PrivateNavBar
);
